module.exports = __webpack_public_path__ + "font-awesome.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/fonts/font-awesome/font-awesome.ttf?v=4.7.0
// module id = ../../../../../src/fonts/font-awesome/font-awesome.ttf?v=4.7.0
// module chunks = 5